import React from 'react';
import { styled } from 'styled-components';
import { MEDIA_WIDTHS } from '../theme/Theme';
import { Image } from 'antd';

const Wrapper = styled.div`
    width: 100%;
    .body {
        margin: auto;
        height: 100%;
        width: 100%;
        padding: 120px 0;
        max-width: 1440px;
        .content {
            width: 100%;
            .large-title {
                font-family: 'Karmatic Arcade';
                font-style: normal;
                font-weight: 400;
                font-size: 40px;
                line-height: 56px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #000000;
                text-align: center;
            }
            .content-row {
                display: flex;
                justify-content: center;
                align-items: start;
                .box-content {
                    width: 500px;
                    height: fit-content;
                    text-align: left;
                    padding: 20px;
                    border: 1px solid black;
                    box-shadow: -4px 4px #ea34b0;
                    .title {
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 32px;
                        text-align: center;
                        color: #0e0c0c;
                        text-decoration: underline;
                        display: flex;
                        align-items: flex-end;
                    }
                    .sub-title {
                        font-family: 'Karmatic Arcade';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 24px;
                        line-height: 36px;
                        text-align: center;
                        color: #ea34b0;
                    }
                    .desc {
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 32px;
                        color: #585858;
                    }
                    .step-img {
                        height: 70px;
                    }
                }
                .step-arrow-1 {
                    margin-top: 55px;
                }
                .step-2 {
                    margin-top: 150px;
                }
            }
        }
    }

    ${({ theme }) => theme.mediaWidth.upToMedium`
        .body {
            .content {
                .content-row {
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .box-content {
                        width: 90%;
                        height: fit-content;
                        // .sub-title {
                        //     font-size: 30px;
                        //     line-height: 30px;
                        // }
                        // .step-img {
                        //     height: 50px;
                        // }
                    }
                    .step-arrow-1 {
                        margin-top: 0;
                    }
                    .step-2 {
                        margin-top: 0;
                    }
                }
            }
        }
    `}
    ${({ theme }) => theme.mediaWidth.upToSmall`
        .body {
            .content {
                .content-row {
                    .box-content {
                        // .title {
                        //     font-size: 30px;
                        //     line-height: 30px;
                        // }
                        // .sub-title {
                        //     font-size: 28px;
                        //     line-height: 28px;
                        // }
                        // .desc {
                        //     font-size: 24px;
                        //     line-height: 24px;
                        // }
                    }
                }
            }
        }
    `}
`;

const SpaceLarge = styled.div`
    height: 40px;
`;
const SpaceExtra = styled.div`
    height: 18px;
`;
const SpaceSmall = styled.div`
    height: 10px;
`;

const HowToBuy = () => {
    return (
        <Wrapper>
            <div className="body">
                <div className="content">
                    <p className="large-title">HOW TO BUY BPUNKS?</p>
                    <SpaceLarge />
                    <div className="content-row">
                        <div className="box-content">
                            <div className="title">
                                STEP 1:
                                <div style={{ width: `8px` }} />
                                <Image
                                    className="step-img"
                                    preview={false}
                                    src={require('../assets/landing/step-wallet.svg').default}
                                />
                            </div>
                            <SpaceExtra />
                            <p className="sub-title">CREATE A WALLET</p>
                            <SpaceExtra />
                            <p className="desc">
                                Download MetaMask or any wallet of your choice from the app store or Google Play store
                                for free. Desktop users can download the Google Chrome extension by going to metamask.io
                            </p>
                            <SpaceSmall />
                            <p className="desc">
                                Go to <a href="https://TrusslessWallet.io">https://TrusslessWallet.io</a> and connet
                                your MetaMask.
                            </p>
                        </div>
                        <div style={{ width: `50px`, height: `50px` }} />
                        <div className="box-content step-2">
                            <div className="title">
                                STEP 2:
                                <div style={{ width: `8px` }} />
                                <Image
                                    className="step-img"
                                    preview={false}
                                    src={require('../assets/landing/step-eth.svg').default}
                                />
                            </div>
                            <SpaceExtra />
                            <p className="sub-title">GET ETH</p>
                            <SpaceExtra />
                            <p className="desc">
                                Have ETH in your wallet, which you can bridge for $WETH. If you don&apos;t have any ETH,
                                you can buy it directly on MetaMask, transfer from another wallet, or buy it on another
                                exchange and send it to your wallet.
                            </p>
                            <SpaceSmall />
                            <p className="desc">
                                Then go to Bridge to transfer your ETH to TC network via{' '}
                                <a href="https://trustlessbridge.io/">https://trustlessbridge.io/</a>
                            </p>
                        </div>
                    </div>
                    <div style={{ height: `50px` }} />
                    <div className="content-row">
                        <div className="box-content">
                            <div className="title">STEP 3:</div>
                            <SpaceExtra />
                            <p className="sub-title">GO TO Mint BPUNKS</p>
                            <SpaceExtra />
                            <p className="desc">
                                Connect your wallet. Enter approve WETH amount you want to approve and click approve,
                                then Click Mint.
                            </p>
                            <SpaceSmall />
                            <p className="desc">
                                When MetaMask prompts you for a wallet signature, confirm your transaction.
                            </p>
                            <SpaceSmall />
                            <p className="desc">Trusswallet.io required BTC in your wallet.</p>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default HowToBuy;
